import AssetLoader from "../../../libs/phaserextension/assets/AssetLoader";
import * as GameModel from "../../models/GameModel";
import { SafeUtils } from "../../PhaserExtension";
import SchoolAssetPack from "./SchoolAssetPack";
import { getAssetPack } from "./SchoolAssetPack";

export default class SchoolAssetLoader extends AssetLoader
{
    constructor()
    {
        super();
    }
    /**
     * Sets up Phaser.Loader objects for Phaser.State::preload.
     * Use this inside of the Phaser.State preload function only.
     * @param {Phaser.Game} game
     * @param {string[]} assetPackKeys
     */
    preloadAssetPacks(game, assetPackKeys)
    {
        // Begin setting up loaders for each asset pack provided.
        for (let i = 0; i < assetPackKeys.length; i++)
        {
            let key = assetPackKeys[i];
            // Make sure the asset pack exists within the asset pack map.
            if (SafeUtils.exists(this.assetPacks[key]))
            {
                // Begin adding loaders for each asset group within the asset pack.
                this.addImageLoaders(game, this.assetPacks[key].images);
                this.addJsonLoaders(game, this.assetPacks[key].json);
                this.addFlumpLoaders(game, this.assetPacks[key].flump);
                this.addAudioLoaders(game, this.assetPacks[key].audio);

                if(this.assetPacks[key].localizedAudio && GameModel.data)
                {
                    if(GameModel.data.english)
                    {
                        this.addAudioLoaders(game, this.assetPacks[key].localizedAudio.english);
                    }
                    else
                    {
                        this.addAudioLoaders(game, this.assetPacks[key].localizedAudio.spanish);
                    }
                }
            }
        }
    }

    /**
     * Unloads all assets belonging to the provided asset packs.
     * @param {string[]} assetPackKeys
     */
    unloadAssetPacks(game, assetPackKeys)
    {
        // Begin unloading each asset pack provided.
        for (let i = 0; i < assetPackKeys.length; i++)
        {
            let key = assetPackKeys[i];
            // Make sure the asset pack exists within the asset pack map.
            if (SafeUtils.exists(this.assetPacks[key]))
            {
                // Begin unloading each asset group within the asset pack.
                this.unloadImages(game, this.assetPacks[key].images);
                this.unloadJson(game, this.assetPacks[key].json);
                this.unloadFlump(game, this.assetPacks[key].flump);
                this.unloadAudio(game, this.assetPacks[key].audio);

                if(this.assetPacks[key].localizedAudio && GameModel.data)
                {
                    if(GameModel.data.english)
                    {
                        this.unloadAudio(game, this.assetPacks[key].localizedAudio.english);
                    }
                    else
                    {
                        this.unloadAudio(game, this.assetPacks[key].localizedAudio.spanish);
                    }
                }
            }
        }
    }

    parseManifest(manifest)
    {
        // Makes sure the manifest exists before trying to parse it.
        if (SafeUtils.exists(manifest))
        {
            for (let key in manifest)
            {
                // Create each asset pack in the manifest and
                // add them to the asset loader's asset pack map.
                this.assetPacks[key] = getAssetPack(manifest[key]);
            }
        }
    }

    loadLocalizedAudio(game, key, array)
    {
        let replacement = GameModel.data.english ? "english" : "spanish";
        let mp3 = array[0].replace("LANG", replacement);
        let ogg = array[1].replace("LANG", replacement);
        game.load.audio(key, [mp3, ogg]);
    }
}
